module.exports = __webpack_public_path__ + "img/bg4.b34ac1e8.png";